import React from "react";
import banner from "../Images/bg_img.webp"; 
import Navbar from "../Home/Navbar";
import Footer from "../Home/Footer";

import './PrivacyPolicy.css'

const PrivacyPolicy = () => {
  return (
    <>
      <Navbar />

      {/* Banner Section */}
      <section className="terms-banner">
        <img src={banner} alt="Privacy Policy" className="banner-image" />
        <div className="banner-overlay">
          <h1>Privacy Policy</h1>
          <p>Guidelines & Policies of Sri Ashtothara Shatha (108) Chukkala Charitable Trust</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="terms-content">
        <div className="terms-container">
          <p>
            We respect and are committed towards protecting your privacy. Publishing, selling, or renting any personal data or information to any third party, without your consent, is against our ethics.
          </p>

          <p>
            The privacy practices of this statement apply to our services available under the domain and subdomains of the Site. By visiting this Site you agree to be bound by the terms and conditions of this privacy policy. If you do not agree, please do not use or access our site.
          </p>

          <p>
            This privacy policy does not apply to sites maintained by other companies or organizations to which we link and we are not responsible for any personal information you submit to third parties via our website. Please ensure that you read the privacy policy of such other companies or organizations before submitting your details.
          </p>

          <p>
            This privacy policy describes the information, as part of the normal operation of our services, we collect from you and what may happen to that information. This policy is inter alia formulated and displayed, to inform you about our information collection/retention policies and practices so that you can make an informed decision, in relation to the sharing of your personal information with us. By accepting the privacy policy and the user agreement or the use of the site in general, you give your consent to our use and disclosure of your personal information in accordance with this privacy policy.
          </p>

          <p>
            This Privacy Policy is incorporated into and subject to the terms of the User Agreement. This privacy policy is effective upon acceptance of access by you to the site.
          </p>

          <h3>Privacy Guarantee</h3>
          <p>
            We agree that we will not sell or rent your personal information to third parties for their marketing purposes without your explicit consent. From time to time, we may reveal general statistical information about our Site and visitors, such as number of visitors, number and type of goods and services purchased, etc. Only those of our employees who need access to your information in order to perform their duties are allowed such access. Any employee who violates our privacy and/or security policies is subjected to disciplinary action, including possible termination and civil and/or criminal prosecution.
          </p>

          <h3>Information We Collect</h3>
          <p>
            Personal Information is used for two general purposes: to process your order and to provide you with the best possible services. Unless otherwise stated explicitly, this policy applies to personal information as disclosed on any of the media.
          </p>

          <p>
            We have appropriate physical, electronic, and managerial procedures to safeguard and secure the information we collect online. We use data collection devices such as “cookies” on certain pages of the Site to help analyze web page flow, measure promotional effectiveness, and promote trust and safety. Cookies are small files placed on your hard drive that assist us in providing our services. You are free to decline cookies if your browser permits.
          </p>

          <h3>Cookie Policy</h3>
          <p>
            <strong>Why are cookies important?</strong> Cookies help you make your online experience more efficient and relevant to your interests. They remember preferences, user ID, contents of shopping baskets, and help navigate between pages efficiently.
          </p>
          <p>
            <strong>What is a Cookie?</strong> A cookie is a small file on your computer, phone, or other device that saves snippets of text for reference by the website. Cookies can be session cookies (erased when browser closes) or persistent cookies (remain until expiration or manual deletion).
          </p>
          <p>
            <strong>Categories of Cookies:</strong>
            <ul>
              <li><strong>Essential:</strong> Required for regular operation of the website.</li>
              <li><strong>Functional:</strong> Remember your preferences and enhance experience.</li>
              <li><strong>Analytics:</strong> Measure performance, understand visits, and popular content. Google Analytics may be used.</li>
              <li><strong>Advertising:</strong> Enable relevant advertisements. Third-party sources are validated and restricted to trusted partners.</li>
            </ul>
          </p>
          <p>
            To delete cookies from your browser, check your browser’s settings. Compliance with our policies requires restricting third-party cookies to trusted partners.
          </p>

          <p>
            You may also change other privacy and security settings under the same section in your browser.
          </p>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
